import { useState } from 'react'
import { useTaskStatuses, useTasks } from '../api/queries'
import { TaskItem } from '../components/TaskItem'
import { EmptyState, ErrorBox, Loading } from '../components/ui'

type Filter = 'all' | 'overdue' | 'soon'

/** Opgaver på tværs af projekter med de filtre der bruges oftest i hverdagen. */
export function TasksPage() {
  const [filter, setFilter] = useState<Filter>('all')
  const [statusId, setStatusId] = useState('')

  const { data: statuses } = useTaskStatuses()
  const { data, isLoading, error } = useTasks({
    statusId: statusId || undefined,
    overdue: filter === 'overdue' ? true : undefined,
    dueWithinDays: filter === 'soon' ? 7 : undefined
  })

  return (
    <>
      <div className="row" style={{ marginBottom: 16, flexWrap: 'wrap' }}>
        <div className="btn-group">
          <button className={`btn btn--sm ${filter === 'all' ? 'btn--primary' : ''}`} onClick={() => setFilter('all')}>
            Alle
          </button>
          <button className={`btn btn--sm ${filter === 'soon' ? 'btn--primary' : ''}`} onClick={() => setFilter('soon')}>
            Deadline snart
          </button>
          <button
            className={`btn btn--sm ${filter === 'overdue' ? 'btn--primary' : ''}`}
            onClick={() => setFilter('overdue')}
          >
            Forsinkede
          </button>
        </div>

        <select style={{ maxWidth: 180 }} value={statusId} onChange={(event) => setStatusId(event.target.value)}>
          <option value="">Alle statusser</option>
          {statuses?.map((status) => (
            <option key={status.id} value={status.id}>
              {status.name}
            </option>
          ))}
        </select>
      </div>

      {isLoading && <Loading />}
      {error && <ErrorBox error={error} />}
      {data && data.items.length === 0 && <EmptyState>Ingen opgaver matcher filteret.</EmptyState>}

      {data && data.items.length > 0 && (
        <div className="stack">
          {data.items.map((task) => (
            <TaskItem key={task.id} task={task} />
          ))}
        </div>
      )}
    </>
  )
}
